<template>
  <el-date-picker
    v-model="getPeriod"
    type="daterange"
    align="right"
    unlink-panels
    :clearable="false"
    range-separator="До"
    format="dd.MM.yyyy"
    start-placeholder="нач. период"
    end-placeholder="конеч. период"
    size="mini"
    @change="handleChange"
    :picker-options="pickerOptions"
    :default-time="defaultTime"
  />
</template>

<script>
  // global date-picker

  // config
  import { getPickerOptions } from "./config";

  // libraries
  import moment from "moment/moment";

  // actions
  import { SET_GLOBAL_MAIN_PERIOD } from "../../store/actions/datePeriod";

  export default {
    name: "PeriodRange",
    props: {
      chartName: {
        type: String
      }
    },
    data() {
      return {
        defaultTime: ["00:00:00", "23:59:59"],
        format: "YYYY-MM-DD HH:mm:ss",
        title: "",
        isChanged: false,
      };
    },
    methods: {
      handleChange() {
        this.isChanged = true;
      },
      getMethod({method, title}) {
        this.method = method;
        this.title = title;
      }
    },
    computed: {
      pickerOptions() {
        return getPickerOptions(
          this.$store.getters.retrospective(this.$route.params.threadId),
          this.getMethod,
          this.chartName,
        );
      },
      getPeriod: {
        get() {
          const localPeriod = this.$store.getters.getGlobalCommonPeriod.map(item => item.replace(" ", "T"))
          const retro_max = this.$store.getters.retro_max(this.$route.params.threadId)
          const retrospective = this.$store.getters.retrospective(this.$route.params.threadId)
          let end = new Date(retro_max);
          end.setDate(end.getDate() - 1);
          let condition = retro_max != null && new Date(retro_max) < new Date(localPeriod[1])
          return [`${condition ? retrospective : localPeriod[0].replace(" ", "T")}`, `${condition ? end.toJSON().split('T')[0] : localPeriod[1].split(' ')[0]}`.replace(" ", "T")];
        },
        set(value) {
          let period = value;

          const diff = Math.round(( Date.parse(period[0]) - Date.parse(period[1]) ) / 86400000) + 1;

          if (diff === 1) {
            const startDate = new Date(period[0]);

            startDate.setHours(0);
            startDate.setMinutes(0);
            startDate.setSeconds(0);

            period = [startDate, new Date()];
          }

          this.$store.dispatch(SET_GLOBAL_MAIN_PERIOD, {
            chart: this.chartName,
            period: period.map(item => moment(item).format(this.format)),
            title: this.title,
            method: this.method,
            thread: this.$route.params.threadId
          });
        }
      }
    },
  };
</script>
